/**
 * "Reads as: SQL Server · PostgreSQL · MySQL" — plain buttons, one per engine that reads the pasted string alike (Option
 * C C3, ruling after review r5). The picked one is pressed; what it fills is previewed below, and Continue / Apply waits
 * for a pick.
 */
import { Fragment } from 'react';
import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';
import type { DatabaseEngine } from '../../components/connectionFormSchema';
import { engineLabelOf } from './pastePreview';

type Props = { engines: readonly DatabaseEngine[]; picked: DatabaseEngine | null; onPick: (engine: DatabaseEngine) => void };

export function PasteReadsAs({ engines, picked, onPick }: Props) {
  return (
    <div role="group" aria-label="Reads as" className="flex flex-wrap items-center gap-1 text-xs" data-testid="connection-string-reads-as" data-picked={picked ?? undefined}>
      <span className="mr-0.5 text-muted-foreground">Reads as:</span>
      {engines.map((engine, index) => (
        <Fragment key={engine}>
          {index > 0 && <span aria-hidden className="text-muted-foreground">·</span>}
          <Button
            type="button"
            variant="ghost"
            size="xs"
            aria-pressed={picked === engine}
            className={cn('h-6 px-1.5 text-xs', picked === engine && 'bg-primary/10 font-medium text-primary hover:bg-primary/15 hover:text-primary')}
            onClick={() => onPick(engine)}
            data-testid={`connection-string-reads-as-${engine}`}
          >
            {engineLabelOf(engine)}
          </Button>
        </Fragment>
      ))}
    </div>
  );
}
